import fr from 'facet-rest';
import { metaOverrideSet as defaultFDModalMetaOverrideSet } from 'Views/Page/Content/Modal/Layouts/DefaultFDModal';
import { overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import {
  HeadlineTextLarge, HeadlineTextMedium, HeadlineTextSmall,
} from 'Packages/FacetDesign/Components';
import CapitalizeLabeledInfo from 'Views/Page/Content/Modal/Layouts/ConciergeTransactionTemplate/CapitalizeLabeledInfo';

export default fr.metaOverride({ base: defaultFDModalMetaOverrideSet })
  .nameOverride('title', {
    _component: () => HeadlineTextLarge,
    hidden: false,
    _customProps: {
      color: 'textSecondary',
      align: 'center',
    },
  }, overrideReadOnly)
  .nameOverride('header', {
    _component: () => HeadlineTextMedium,
  }, overrideReadOnly)
  .nameOverride('nextStepsTitle', {
    _component: () => HeadlineTextSmall,
  }, overrideReadOnly)
  .nameOverride(['status', 'from', 'to', 'lastUpdated'], {
    _component: () => CapitalizeLabeledInfo,
  }, overrideReadOnly);
